import * as React from "react";
import {Component} from "react";

interface IStarsProps {
    value: number;
    isFixed?: boolean;
    onReviewChange?: any;
}

interface IStarsState {
    stars: any;
    hoverIndex: number;
}

class Stars extends Component<IStarsProps, IStarsState> {

    public starStyle = {
        color: 'gold',
        cursor: 'pointer',
        margin: '0px -2px',
        padding: 0
    };

    public constructor(props: IStarsProps) {
        super(props);

        this.state = {
            stars: this.createStars(props.value),
            hoverIndex: 0
        };
    };

    public componentDidUpdate(prevProps: Readonly<IStarsProps>, prevState: Readonly<IStarsState>, snapshot?: any) {
        if (prevProps.value !== this.props.value) {
            this.setState({
                stars: this.createStars(this.props.value)
            });
        }
    };

    public createStars(value: number) {
        const stars = [];
        for (let i = 1; i <= 5; i++) {
            stars.push({
                index: i,
                filled: i <= value,
                half: (value > i - 1 && value < i)
            });
        }
        return stars;
    };

    public render() {
        if (this.props.isFixed) {
            return <React.Fragment>
                {
                    this.state.stars.map((star: any) => {
                        return <span
                            key={star.index}
                            className="RatingStar"
                        >
                        {
                            this.state.hoverIndex ? (this.state.hoverIndex >= star.index ? "●" : "○")
                                : (star.filled ? "●" : (star.half ? "◐" : "○"))
                        }
                    </span>;
                    })
                }
            </React.Fragment>;
        } else {
            return <React.Fragment>
                {
                    this.state.stars.map((star: any) => {
                        return <span
                            key={star.index}
                            className="RatingStar Clickable"
                            onMouseOver={() => {
                                this.setState({
                                    hoverIndex: star.index
                                });
                            }}
                            onMouseOut={() => {
                                if (this.state.hoverIndex === star.index) {
                                    this.setState({
                                        hoverIndex: 0
                                    });
                                }
                            }}
                            onClick={() => {
                                if (this.props.value !== star.index) {
                                    this.props.onReviewChange(star.index);
                                }
                            }}
                        >
                        {
                            this.state.hoverIndex ? (this.state.hoverIndex >= star.index ? "●" : "○")
                                : <></>
                        }
                        {
                            !this.state.hoverIndex ? (this.props.value >= star.index ? "●" : "○")
                                : <></>
                        }
                    </span>;
                    })
                }
            </React.Fragment>;
        }
    };
}

export default Stars;



// WEBPACK FOOTER //
// ./src/components/model/ModelInfo/Stars.tsx